export default {
  functionKey: "PUISSANCE",
  title: "PUISSANCE",
  group: "Calcul",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 1,
  requiredArguments: [{ argumentKey: "Power", name: "Puissance" }],
  expectedArguments: [
    { name: "Puissance", argumentKey: "Power", single: true, initialValue: "2", autoFill: "2" }
  ],
  description: "Elève un nombre à la puissance donnée en argument.",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    if (args.length === 0) {
      args.push("2");
    } else if (isArgumentCol[0] === false) {
      args[0] = args[0].replace(/'/g, "");
    }
    const jsCode = `${destination} = Math.pow(${origin}, ${args[0]});`;
    const safeCode = `
      if (!isNaN(parseInt(${origin}))) {
        ${jsCode}
      } else {
        ${destination} = '';
      }`;
    return { displayCode: jsCode, safeCode };
  }
}
